import { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ChatContext, ChatContextInterface } from "./MSRContext";
import LoadingPage from "./LoadingPage";

export default function AuthGuide() {
  const navigate = useNavigate();
  const { loading } = useContext(ChatContext) as ChatContextInterface;
  const isAuthenticated = Boolean (localStorage.getItem("isAuthenticated"));
  const wrapper = Boolean (localStorage.getItem("wrapper"));
 
  console.log("In auth", loading, isAuthenticated, wrapper);

  useEffect(() => {
    if (loading) return;

    if (!wrapper && !isAuthenticated) {
      console.log("should navigate to login page");
      navigate("/login");
    } else if (wrapper && isAuthenticated) {
      console.log("should navigate to home page");
      const lastVisitedRoute = sessionStorage.getItem("lastVisitedRoute");
      if (lastVisitedRoute && lastVisitedRoute !== window.location.pathname) {
        navigate(lastVisitedRoute); // Navigate back to the last visited route
      }
    }
  }, [isAuthenticated, loading, wrapper, navigate]);

  if (loading) {
    console.log("loading...");
    return <LoadingPage />;
  }

  return <Outlet />;
}
